class BuyingGuideCategories extends HTMLElement {
  connectedCallback() {
    this.tabs = this.querySelectorAll('[data-tab]');
    this.cards = this.querySelectorAll('[data-category]');
    this.defaultTab = this.dataset.defaultTab || 'all';

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => this.activateTab(tab));
    });

    const activeTab =
      [...this.tabs].find((t) => t.dataset.tab === this.defaultTab) || this.tabs[0];
    if (activeTab) this.activateTab(activeTab);
  }

  activateTab(tab) {
    const tabId = tab.dataset.tab;

    this.tabs.forEach((t) => {
      const isActive = t === tab;
      t.classList.toggle('is-active', isActive);
      t.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    this.cards.forEach((card) => {
      const tag = card.dataset.category || 'all';
      const show = tabId === 'all' || tag === 'all' || tag === tabId;
      card.classList.toggle('is-hidden', !show);
      card.hidden = !show;
    });
  }
}

if (!customElements.get('buying-guide-categories')) {
  customElements.define('buying-guide-categories', BuyingGuideCategories);
}
